import moment from "moment";

//Importar lista de enum


import dicas from "../tips";
import enums from "../enum";

//import config from "@/common/config";

const parseDataSegura = (data) => {
  if (!data) return moment.invalid();
  if (moment.isMoment(data)) return data.clone();

  if (data instanceof Date) return moment(data);

  if (typeof data === "string") {
    const dataBr = data.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?$/);
    if (dataBr) {
      const dia = parseInt(dataBr[1], 10);
      const mes = parseInt(dataBr[2], 10) - 1;
      const ano = parseInt(dataBr[3], 10);
      const hora = parseInt(dataBr[4] || "0", 10);
      const minuto = parseInt(dataBr[5] || "0", 10);
      return moment({ year: ano, month: mes, day: dia, hour: hora, minute: minuto, second: 0, millisecond: 0 });
    }
  }

  return moment(data, [
    "YYYY-MM-DD",
    "YYYY-MM-DD HH:mm",
    "YYYY-MM-DDTHH:mm:ss",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
    moment.ISO_8601,
  ], true);
};

const formatarDataBr = (data, hora = false) => {
  let formato = !hora ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm";
  return parseDataSegura(data).format(formato);
};

const adicionarValorData = (data, valor, propriedade = 'D') => {
  return parseDataSegura(data).add(valor, propriedade);
}

const formatarDataBD = (data, hora = false) => {
  let formato = !hora ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm";
  return moment(data, !hora ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm").format(formato);
};

const formatarData = (data, formato) => {
  return parseDataSegura(data).format(formato);
};

const retornarNomeMes = (mes) => {
  let meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ];
  return meses[mes - 1];
};


const retornarIndiceMes = (mes) => {
  let meses = [
    {id : 1 , nome : "Janeiro"},
    {id : 2 , nome : "Fevereiro"},
    {id : 3 , nome : "Março"},
    {id : 3 , nome : "Marco"},
    {id : 4 , nome : "Abril"},
    {id : 5 , nome : "Maio"},
    {id : 6 , nome : "Junho"},
    {id : 7 , nome : "Julho"},
    {id : 8 , nome : "Agosto"},
    {id : 9 , nome : "Setembro"},
    {id : 10 , nome : "Outubro"},
    {id : 11 , nome : "Novembro"},
    {id : 12 , nome : "Dezembro"}
  ];
  return meses.find(x => x.nome == mes).id;
};


const criarArrayMes = (dataInicio, duracao, numeroMes = false, retornaAno = true) => {
  let meses = [];
  
  let ano = formatarData(dataInicio, 'YYYY');
  let mes = formatarData(dataInicio, 'MM');

  for (let index = 0; index < duracao; index++) {
      meses.push({
          value: index + 1,
          text: !numeroMes ? `${retornarNomeMes(mes)}${retornaAno ? `/${ano}` : ''}` : `Mês ${index + 1}`,
          mes: mes,
          ano: ano,
          enum: retornarNomeMes(mes).replace('ç','c')
      });

      mes++;
      if (mes > 12) {
          mes = 1;
          ano++;
      }
  }

  return meses;
}

const criarArrayMesCronogramaFinanceiro = (dataInicio, duracao, numeroMes = false, retornaAno = true) => {
  let meses = [];
  
  let ano = formatarData(dataInicio, 'YYYY');
  let mes = formatarData(dataInicio, 'MM');
  for (let index = 0; index <= duracao; index++) {
      meses.push({
          value: index+1,
          text: !numeroMes ? `${retornarNomeMes(mes)}${retornaAno ? `/${ano}` : ''}` : `Mês ${index+1}`,
          mes : mes,
          ano : ano,
          enum: retornarNomeMes(mes).replace('ç','c')
      });  
      
      mes++;
      if(mes > 12){
          mes = 1;
          ano++;
      }
  }
  return meses;
}
const retornarMeses = () => {
  return criarArrayMes('01/01/2019', 12, false, false);
}

const formatarValor = (value) => {
  value = parseFloat(value);
  value = value.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
  return value;
};

const baixarBase64 = (arquivo, nomearquivo) => {
  var a = document.createElement("a");
  a.href = `${arquivo}`;
  a.download = nomearquivo;
  a.click();
};

const baixarArquivo = (arquivo, headers) => {
  let splited = headers['content-disposition'].split(';')[1];
  let fileName = splited.replaceAll("\"", '').replace(' filename=','');
  let blob = new Blob([arquivo], { type: headers['content-type'] });
  let url = window.URL.createObjectURL(blob);
  let link = document.createElement('a');

  link.type = "hidden";
  link.href = url;
  link.download=  fileName;
  document.body.appendChild(link);
  
  link.click();
  link.remove();
};

const removerValor = (valor) => {
  return valor.replace('R$','').replace(/\./g, '').replace(',', '.').replace(' ','').trim();
};

const serialize = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });

  let str =
    "?" +
    Object.keys(obj)
      .reduce(function(a, k) {
        a.push(k + "=" + encodeURIComponent(obj[k]));
        return a;
      }, [])
      .join("&");
  return str;
};

const removerMascara = (str) => {
  if (str == null || str == undefined || str == "") return "";
  return str.replace(/[^\d]+/g, "");
};

const validarEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const validarCpfCnpj = (cpfCnpj) => {
  cpfCnpj = removerMascara(cpfCnpj);
  return cpfCnpj.length == 11 ? validarCPF(cpfCnpj) : validarCNPJ(cpfCnpj);
};

const validarCPF = (cpf) => {
  cpf = removerMascara(cpf);
  if (cpf == "") return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999"
  )
    return false;
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(9))) return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11) rev = 0;
  if (rev != parseInt(cpf.charAt(10))) return false;
  return true;
};

const validarCNPJ = (cnpj) => {
  cnpj = removerMascara(cnpj);

  if (cnpj == "") return false;

  if (cnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
};

const validarCep = (cep) => {
  cep = removerMascara(cep);
  let objER = /^[0-9]{2}[0-9]{3}[0-9]{3}$/;

  if (cep.length > 0) {
    if (objER.test(cep)) return true;
    else {
      return false;
    }
  } else {
    return false;
  }
};

const maskCnpj = (v) => {
  v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
  v = v.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
  v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
  v = v.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
  v = v.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
  return v;
};

const validarAcesso = (acesso) => {
  let claims = JSON.parse(localStorage.getItem("claims"));
  claims = claims.sort((a, b) => {
    return a.value.length - b.value.length;
  });
  let acessos = {};

  for (const key in claims) {
    if (Object.hasOwnProperty.call(claims, key)) {
      if (!acessos[claims[key].type]) {
        acessos[claims[key].type] = {
          type: claims[key].type,
          vizualizar: false,
          criar: false,
          editar: false,
          deletar: false,
        };
      }

      acessos[claims[key].type].vizualizar = claims[key].value.indexOf("R") > -1;
      acessos[claims[key].type].criar = claims[key].value.indexOf("C") > -1;
      acessos[claims[key].type].editar = claims[key].value.indexOf("U") > -1;
      acessos[claims[key].type].deletar = claims[key].value.indexOf("D") > -1;
    }
  }
  return acessos[acesso] || {};
};

const transposeJson = (keyT, array, reduce) => {
  if (reduce) return array.reduce((a, v) => ({ ...a, [v]: v }), {});
  let json = {};

  for (const key in array) {
    if (Object.hasOwnProperty.call(array, key)) {
      if (!json[array[key][keyT]]) {
        json[array[key][keyT]] = { ...array[key] };
      }
    }
  }
  return json || {};
};

const formatarTelefone = (v) => {
  v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
  if (v.length >= 10) {
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
  }
  v = v.replace(/(\d)(\d{4})$/, "$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos

  return v;
};

const formatarCPF = (v) => {
  v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
  v = v.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4"); //Coloca parênteses em volta dos dois primeiros dígitos
  return v;
};

const formatarCep = (v) => {
  v = v.replace(/\D/g, "");
  v = v.replace(/^(\d{5})(\d)/, "$1-$2");

  return v;
};

const pegarCorpo = (mensagem) => {
  var html = document.createElement('div');
  html.innerHTML = mensagem;
  let corpo = html.getElementsByClassName('corpo')[0].innerHTML;    
  
  return corpo.replace(/<\/?[^>]+(>|$)/g, "");
};

const pegarTitulo = (mensagem) => {
  var html = document.createElement('div');
  html.innerHTML = mensagem;
  let titulo = html.getElementsByClassName('titulo-vue');    

  if(titulo.length == 0){
      return "";
  }
  
  return titulo[0].innerHTML.replace(/<\/?[^>]+(>|$)/g, "");
};


export default {
  formatarDataBr,
  formatarDataBD,
  formatarData,
  retornarNomeMes,
  retornarIndiceMes,
  retornarMeses,
  removerMascara,
  validarEmail,
  validarCpfCnpj,
  transposeJson,
  validarCPF,
  validarCNPJ,
  validarCep,
  validarAcesso,
  maskCnpj,
  formatarValor,
  removerValor,
  formatarTelefone,
  formatarCep,
  serialize,

  formatarCPF,
  criarArrayMes,
  criarArrayMesCronogramaFinanceiro,
  baixarBase64,
  baixarArquivo,

  pegarCorpo,
  pegarTitulo,
  adicionarValorData,

  ...dicas,
  ...enums,
};
